import React from 'react';

import Styles from './index.module.scss';

interface Props {
	children?: React.ReactNode;
	style?: React.CSSProperties;
}

export const Widget = ({ children, style }: Props) => {
	return (
		<div className={Styles.card}>
			<div className={Styles.border} style={style}>
				<div className={Styles.chart}>{children}</div>
			</div>
		</div>
	);
};
